import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { MapPin, X, Plus } from "lucide-react";

export default function RegioesAtendimento() {
  const [cidades, setCidades] = useState([]);
  const [estados, setEstados] = useState([]);
  const [novaCidade, setNovaCidade] = useState("");
  const [novoEstado, setNovoEstado] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/montadora/regioes-atendidas")
      .then(r => { setCidades(r.data.cidades_atendidas || []); setEstados(r.data.estados_atendidos || []); })
      .catch(e => toast.error(formatApiError(e)));
  }, []);

  const addCidade = () => {
    const c = novaCidade.trim();
    if (!c) return;
    if (cidades.some(x => x.toLowerCase() === c.toLowerCase())) { toast.info("Cidade já adicionada"); return; }
    setCidades([...cidades, c]); setNovaCidade("");
  };
  const addEstado = () => {
    const e = novoEstado.trim().toUpperCase();
    if (!e || e.length !== 2) { toast.info("Informe a sigla UF (ex.: RJ)"); return; }
    if (estados.includes(e)) return;
    setEstados([...estados, e]); setNovoEstado("");
  };

  const salvar = async () => {
    if (cidades.length === 0) { toast.error("Informe pelo menos uma cidade atendida"); return; }
    setSaving(true);
    try {
      await api.put("/montadora/regioes-atendidas", { cidades_atendidas: cidades, estados_atendidos: estados });
      toast.success("Regiões de atendimento atualizadas!");
    } catch (e) { toast.error(formatApiError(e)); }
    setSaving(false);
  };

  return (
    <div className="space-y-6" data-testid="regioes-atendimento-page">
      <div>
        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-aj-orange">Rede</div>
        <h1 className="font-display font-extrabold text-2xl sm:text-3xl text-aj-blue-deep mt-1">Regiões Atendidas</h1>
        <p className="text-sm text-aj-text-muted mt-1 max-w-2xl">
          Informe todas as cidades e regiões onde sua montadora atende — não apenas a sede.
          Empresas encontram parceiras pela região e a distribuição de OS respeita essas áreas.
        </p>
      </div>

      <div className="aj-card p-5 space-y-4">
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-aj-text-muted mb-2">Cidades atendidas</div>
          <div className="flex flex-wrap gap-2 mb-3">
            {cidades.length === 0 && <span className="text-sm text-aj-text-muted">Nenhuma cidade cadastrada.</span>}
            {cidades.map(c => (
              <span key={c} className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-aj-amber-soft text-aj-orange-hover text-sm font-medium"
                data-testid={`regiao-chip-${c}`}>
                <MapPin size={12} /> {c}
                <button onClick={() => setCidades(cidades.filter(x => x !== c))}
                  className="ml-1 hover:text-[#E60000]" data-testid={`regiao-remover-${c}`}>
                  <X size={13} />
                </button>
              </span>
            ))}
          </div>
          <div className="flex gap-2 max-w-md">
            <Input value={novaCidade} onChange={e => setNovaCidade(e.target.value)}
              onKeyDown={e => e.key === "Enter" && addCidade()}
              placeholder="Ex.: Niterói" data-testid="regiao-nova-cidade" />
            <Button variant="outline" onClick={addCidade} data-testid="regiao-add-cidade">
              <Plus size={15} /> Adicionar
            </Button>
          </div>
        </div>

        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-aj-text-muted mb-2">Estados (UF)</div>
          <div className="flex flex-wrap gap-2 mb-3">
            {estados.map(uf => (
              <span key={uf} className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-[#DBEAFE] text-[#142766] text-sm font-bold">
                {uf}
                <button onClick={() => setEstados(estados.filter(x => x !== uf))} className="ml-1 hover:text-[#E60000]">
                  <X size={13} />
                </button>
              </span>
            ))}
          </div>
          <div className="flex gap-2 max-w-md">
            <Input value={novoEstado} onChange={e => setNovoEstado(e.target.value)} maxLength={2}
              onKeyDown={e => e.key === "Enter" && addEstado()}
              placeholder="UF (ex.: RJ)" className="w-28" data-testid="regiao-novo-estado" />
            <Button variant="outline" onClick={addEstado} data-testid="regiao-add-estado">
              <Plus size={15} /> Adicionar
            </Button>
          </div>
        </div>

        <div className="pt-3 border-t border-[#E2E8F0]">
          <Button onClick={salvar} disabled={saving} className="btn-aj-primary" data-testid="regioes-salvar">
            {saving ? "Salvando..." : "Salvar regiões"}
          </Button>
        </div>
      </div>
    </div>
  );
}
